export default __webpack_public_path__ + "static/media/ruler.512cd38d.jpg";